import { Theme, alpha } from "@mui/material/styles";

// The compact report-table look the design rules ask for on every รับจ่าย table: a tinted
// sticky header, zebra rows, a sticky totals row, figures right-aligned in tabular digits.

const ROW_HOVER_OPACITY = 0.08;

export const TABLE_SX = {
  fontVariantNumeric: "tabular-nums",
  "& td, & th": { whiteSpace: "nowrap", py: 1, px: 1.5 },
} as const;

export const HEAD_ROW_SX = {
  "& th": {
    bgcolor: (theme: Theme) => theme.palette.background.default,
    fontWeight: 600,
  },
} as const;

/** Opaque zebra, so a pinned cell hides what scrolls under it. */
export const BODY_ROW_SX = {
  bgcolor: "background.paper",
  "&:nth-of-type(even)": { bgcolor: (theme: Theme) => theme.palette.grey[50] },
} as const;

/** Pins a column to one edge of a table that scrolls sideways (its row's background shows). */
export const stickyCellSx = (side: "left" | "right") => ({
  position: "sticky",
  [side]: 0,
  zIndex: 1,
  bgcolor: "inherit",
});

/** A row that opens something: the pointer and the hover say so. */
export const CLICKABLE_ROW_SX = {
  ...BODY_ROW_SX,
  cursor: "pointer",
  "&:hover": {
    bgcolor: (theme: Theme) => alpha(theme.palette.primary.main, ROW_HOVER_OPACITY),
  },
} as const;

export const FOOT_ROW_SX = {
  "& td": {
    position: "sticky",
    bottom: 0,
    bgcolor: (theme: Theme) => theme.palette.grey[200],
    color: "text.primary",
    fontWeight: 600,
    fontSize: "0.875rem",
    borderTop: 2,
    borderColor: "divider",
  },
} as const;

/** The scroll box a long table sits in, so its header and totals row stay in view. */
export const tableContainerSx = (maxHeight: number) => ({
  maxHeight,
  border: 1,
  borderColor: "divider",
  borderRadius: 2,
});
